import tw from "twin.macro";

export const Button = tw.button`bg-blue-200 border border-blue-500 text-blue-700 p-1 text-sm`;
